import { Sparkles } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 px-4"
    >
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div data-testid="about-text">
            <span className="font-hand text-3xl text-[#FF6B9E]">~ our story ~</span>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl text-gray-900 mt-2 mb-6 leading-tight">
              We started a <span className="text-[#4DB8FF]">club</span> because we love hanging out with kids!
            </h2>
            <p className="text-lg text-gray-700 font-semibold leading-relaxed mb-4">
              The Babysitting Club is six best friends — all 10 and 11 years old — who got together
              because we love games, crafts, silly jokes and making little kids laugh.
            </p>
            <p className="text-lg text-gray-700 font-semibold leading-relaxed">
              We teamed up so parents in our neighborhood can have a date night, a quiet hour, or
              just a break — knowing their little ones are having a blast with us.
            </p>
          </div>

          <div data-testid="about-card" className="relative">
            <div className="bg-[#FFD166] border-4 border-gray-900 rounded-3xl p-8 shadow-pop rotate-2">
              <div className="bg-white border-2 border-gray-900 rounded-2xl p-6 -rotate-3">
                <Sparkles size={32} className="text-[#FF6B9E] mb-3" />
                <p className="font-hand text-3xl text-gray-900 leading-tight mb-2">
                  "We promise: zero boring minutes, and 100% kindness."
                </p>
                <p className="font-bold text-sm text-gray-600 mt-4">— The Club, est. this year 🌟</p>
              </div>
            </div>

            {/* Floating sticker */}
            <div className="absolute -top-6 -left-6 w-20 h-20 bg-[#38E5B6] border-4 border-gray-900 rounded-full flex items-center justify-center font-display text-2xl text-gray-900 shadow-pop-sm animate-wiggle">
              YAY!
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
